import React, { forwardRef } from 'react';
import { number, object, oneOfType, string } from 'prop-types';

import stockService from '@services/stock';
import { cx } from '@emotion/css';

import { styStockIcon } from './style';

const DEFAULT_IMG_SRC =
  'https://storage.googleapis.com/storage-ajaib-prd-platform-template-engine/asset/533.png';
const StockIcon = forwardRef(({ code, className, size }, ref) => {
  // enabled: false, because we just want to read the img from cache
  const { data, isSuccess } = stockService.detail.about.useAbout(code, { enabled: false });

  const getImgSrc = () => {
    if (!isSuccess) {
      return DEFAULT_IMG_SRC;
    }

    return data?.icon_url || DEFAULT_IMG_SRC;
  };

  const imgSrc = getImgSrc();

  return (
    <figure ref={ref} className={cx(styStockIcon({ size }), className)}>
      <img alt={`${code} icon`} src={imgSrc} />
    </figure>
  );
});

StockIcon.propTypes = {
  ref: object,
  code: string,
  className: string,
  size: oneOfType([string, number]),
};

StockIcon.defaultProps = {
  ref: null,
  code: '',
  className: '',
  size: 16,
};

export default StockIcon;
